import { Typography } from "@mui/material";
import { ReactNode } from "react";

type Props = {
  children: ReactNode;
};

const EmptySection = ({ children }: Props) => (
  <Typography
    align="center"
    sx={{
      color: "text.secondary",
      flexGrow: 1,
      mt: 3,
    }}
  >
    {children}
  </Typography>
);

export default EmptySection;
